





































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { Handout } from '@/interfaces/handouts/handouts';
import { Round } from '../../../interfaces/rounds/rounds';

@Component
export default class SingleRound extends Vue {
  @Prop()
  private round!: Round;

  @Prop({ default: true })
  private editable!: boolean;

  private roundSaving = false;
  private isDownloadingId: string | null = null;
  private error: Error | null = null;

  get handouts() {
    if (!this.round.handouts) {
      return [];
    }
    return this.round.handouts.filter((handout: Handout) => {
      if (handout.visibility === 'group') {
        return true;
      } else {
        return handout.visibleFor.includes(this.$store.getters.getUser.uid);
      }
    });
  }

  public editRound() {
    this.$emit('round:edit', this.round.id);
  }

  public formatDate(date: string) {
    const dateParts = date.split('-');
    return dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0];
  }

  private downloadHandout(handout: Handout) {
    this.isDownloadingId = handout.id;
    this.$store
      .dispatch('loadHandoutUrl', handout.fileName)
      .then((url) => {
        window.open(url);
      })
      .catch((error) => {
        this.error = error;
      })
      .finally(() => {
        this.isDownloadingId = null;
      });
  }
}
